const STROKE = {
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
};

const icons = {
    aries: (
        <>
            <path d="M6 18c2-4 4-8 6-10" {...STROKE} />
            <path d="M18 18c-2-4-4-8-6-10" {...STROKE} />
            <path d="M12 8V5" {...STROKE} />
        </>
    ),
    taurus: (
        <>
            <circle cx="12" cy="13" r="5.5" {...STROKE} />
            <path d="M8.5 7.5c1.2-1.8 2.4-2.5 3.5-2.5s2.3.7 3.5 2.5" {...STROKE} />
        </>
    ),
    gemini: (
        <>
            <path d="M8 4v16M16 4v16" {...STROKE} />
            <path d="M6 4h12M6 20h12" {...STROKE} />
        </>
    ),
    cancer: (
        <>
            <path d="M9 8c-2.5 0-4 1.8-4 4s1.5 4 4 4" {...STROKE} />
            <path d="M15 16c2.5 0 4-1.8 4-4s-1.5-4-4-4" {...STROKE} />
            <circle cx="9" cy="8" r="1" fill="currentColor" stroke="none" />
            <circle cx="15" cy="16" r="1" fill="currentColor" stroke="none" />
        </>
    ),
    leo: (
        <>
            <circle cx="11" cy="12" r="5" {...STROKE} />
            <path d="M16 12c2 0 4 1.5 4 4.5 0 2.5-1.5 4.5-4 5.5" {...STROKE} />
        </>
    ),
    virgo: (
        <>
            <path d="M7 5v11M11 5v11M15 5v8c0 2.5-1 4-3 4" {...STROKE} />
            <path d="M12 19v-2" {...STROKE} />
            <path d="M10.5 19h3" {...STROKE} />
        </>
    ),
    libra: (
        <>
            <path d="M6 8h12" {...STROKE} />
            <path d="M8 8v3h8V8" {...STROKE} />
            <path d="M12 11v5" {...STROKE} />
            <path d="M9 19h6" {...STROKE} />
        </>
    ),
    scorpio: (
        <>
            <path d="M7 5v11M11 5v11M15 5v8c0 2.5-1 4-3 4" {...STROKE} />
            <path d="M15 17l3-3M15 17l3 3M15 17h3" {...STROKE} />
        </>
    ),
    sagittarius: (
        <>
            <path d="M6 18L18 6" {...STROKE} />
            <path d="M11 6h7v7" {...STROKE} />
            <path d="M6 13l5 5" {...STROKE} />
        </>
    ),
    capricorn: (
        <>
            <path d="M8 5v10c0 2.5 1.5 4 4 4" {...STROKE} />
            <path d="M12 19c2.5 0 4-1.5 4-4" {...STROKE} />
            <path d="M16 15c1.5-1 2.5-2.5 2.5-4.5" {...STROKE} />
            <circle cx="18.5" cy="9.5" r="1" fill="currentColor" stroke="none" />
        </>
    ),
    aquarius: (
        <>
            <path d="M5 8c2-2 4-2 6 0s4 2 6 0" {...STROKE} />
            <path d="M5 13c2-2 4-2 6 0s4 2 6 0" {...STROKE} />
            <path d="M5 18c2-2 4-2 6 0s4 2 6 0" {...STROKE} />
        </>
    ),
    pisces: (
        <>
            <path d="M7 6c-2.5 2-2.5 5 0 7s2.5 5 0 7" {...STROKE} />
            <path d="M17 6c2.5 2 2.5 5 0 7s-2.5 5 0 7" {...STROKE} />
            <path d="M5 12h14" {...STROKE} />
        </>
    ),
};

export default function ZodiacIcon({ id, size = 56, color = '#3B0764', className, style }) {
    const glyph = icons[id];
    if (!glyph) return null;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={{ color, display: 'inline-block', verticalAlign: 'middle', ...style }}
            aria-hidden="true"
        >
            {glyph}
        </svg>
    );
}
